module.exports = "../../../../platform/assets/pageMainIcon/youth_jichudanganlei8.svg";